import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Dialog, DialogButton, DialogTitle, RadioGroup, RadioLabel, Typography } from "@bookips/sds";
import { useEffect, useState } from "react";
const CouponSelectDialog = (param)=>{
    let { isOpen , onClose , availableCoupons , appliedCoupon , onCouponSelect , selectedProductId  } = param;
    const [selectedCouponId, setSelectedCouponId] = useState({
        id: "none",
        discountAmount: 0
    });
    const handleApply = (couponId)=>{
        let success = false;
        if (selectedCouponId.id !== "none") {
            const coupon = availableCoupons.find((coupon)=>coupon.id === couponId);
            success = onCouponSelect(coupon);
        } else {
            success = onCouponSelect(null);
        }
        // 적용 실패 시 선택 상태 유지하고 다이얼로그 유지 (스낵바만 표시)
        if (!success) {
            return;
        }
        onClose();
    };
    const handleChangeCoupon = (couponId)=>{
        if (couponId !== "none") {
            var _availableCoupons_find;
            var _availableCoupons_find_discountValue;
            setSelectedCouponId({
                id: couponId,
                discountAmount: (_availableCoupons_find_discountValue = (_availableCoupons_find = availableCoupons.find((coupon)=>coupon.id === couponId)) === null || _availableCoupons_find === void 0 ? void 0 : _availableCoupons_find.discountValue) !== null && _availableCoupons_find_discountValue !== void 0 ? _availableCoupons_find_discountValue : 0
            });
        } else {
            setSelectedCouponId({
                id: "none",
                discountAmount: 0
            });
        }
    };
    // 다이얼로그 닫힐 때 실제 적용된 쿠폰 상태로 리셋
    const resetToAppliedCoupon = ()=>{
        const currentAppliedCoupon = appliedCoupon(selectedProductId);
        var _currentAppliedCoupon_couponId, _currentAppliedCoupon_discountAmount;
        setSelectedCouponId({
            id: (_currentAppliedCoupon_couponId = currentAppliedCoupon === null || currentAppliedCoupon === void 0 ? void 0 : currentAppliedCoupon.couponId) !== null && _currentAppliedCoupon_couponId !== void 0 ? _currentAppliedCoupon_couponId : "none",
            discountAmount: (_currentAppliedCoupon_discountAmount = currentAppliedCoupon === null || currentAppliedCoupon === void 0 ? void 0 : currentAppliedCoupon.discountAmount) !== null && _currentAppliedCoupon_discountAmount !== void 0 ? _currentAppliedCoupon_discountAmount : 0
        });
    };
    const handleCancelCoupon = ()=>{
        resetToAppliedCoupon();
        onClose();
    };
    const handleDialogClose = ()=>{
        resetToAppliedCoupon();
        onClose();
    };
    useEffect(()=>{
        const currentAppliedCoupon = appliedCoupon(selectedProductId);
        if (currentAppliedCoupon) {
            setSelectedCouponId({
                id: currentAppliedCoupon.couponId,
                discountAmount: currentAppliedCoupon.discountAmount
            });
        } else {
            setSelectedCouponId({
                id: "none",
                discountAmount: 0
            });
        }
    }, [
        selectedProductId
    ]);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: isOpen,
        onOpenChange: handleDialogClose,
        title: /*#__PURE__*/ _jsx(DialogTitle, {
            title: "쿠폰 선택",
            description: "해당 상품에 적용가능한 쿠폰만 표시돼요."
        }),
        classes: {
            contentWrapper: "max-h-[calc(100vh-144px)] max-sm:w-[calc(100vw-40px)] overflow-y-auto"
        },
        footer: /*#__PURE__*/ _jsx(DialogButton, {
            cancelText: "닫기",
            confirmText: "적용",
            onCancel: handleCancelCoupon,
            className: "flex gap-2 mx-7 mb-7 justify-end max-sm:mx-5 max-sm:mb-5",
            classes: {
                cancelButton: "max-sm:w-full",
                confirmButton: "max-sm:w-full"
            },
            onConfirm: ()=>handleApply(selectedCouponId.id)
        }),
        scroll: true,
        children: /*#__PURE__*/ _jsx("div", {
            className: "mx-7 h-full overflow-auto max-sm:mx-5",
            children: /*#__PURE__*/ _jsxs(RadioGroup, {
                className: "flex flex-col gap-3 ",
                onValueChange: (value)=>handleChangeCoupon(value),
                value: (selectedCouponId === null || selectedCouponId === void 0 ? void 0 : selectedCouponId.id) || "none",
                children: [
                    /*#__PURE__*/ _jsx(RadioLabel, {
                        size: "md",
                        value: "none",
                        classes: {
                            root: cn("w-full h-full items-baseline p-5 max-sm:p-4 border border-gray-100 rounded-md", selectedCouponId.id === "none" && "border-primary-main bg-indigo-0"),
                            label: "w-full"
                        },
                        children: /*#__PURE__*/ _jsx(CouponItem, {
                            coupon: null
                        })
                    }, "none"),
                    availableCoupons === null || availableCoupons === void 0 ? void 0 : availableCoupons.map((coupon)=>/*#__PURE__*/ _jsx(RadioLabel, {
                            size: "md",
                            value: coupon.id,
                            classes: {
                                root: cn("w-full h-full items-baseline p-5 max-sm:p-4 border border-gray-100 rounded-md", coupon.id === selectedCouponId.id && "border-primary-main bg-indigo-0"),
                                label: "w-full"
                            },
                            children: /*#__PURE__*/ _jsx(CouponItem, {
                                coupon: coupon
                            })
                        }, coupon.id))
                ]
            })
        })
    });
};
const CouponItem = (param)=>{
    let { coupon  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: coupon ? /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "subtitle1",
                            className: "text-red-400 font-semibold",
                            children: [
                                "적용 시",
                                " ".concat(coupon.discountValue.toLocaleString()).concat(coupon.discountType === "percent" ? "%" : "원", " 할인")
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            className: "text-gray-700 font-medium",
                            children: coupon.name
                        }),
                        coupon.discountMaximumPrice > 0 && /*#__PURE__*/ _jsxs(Typography, {
                            variant: "body2",
                            className: "text-gray-500",
                            children: [
                                "최대 ",
                                coupon.discountMaximumPrice.toLocaleString(),
                                "원 할인"
                            ]
                        }),
                        coupon.minimumPrice > 0 && /*#__PURE__*/ _jsxs(Typography, {
                            variant: "body2",
                            className: "text-gray-500",
                            children: [
                                "쿠폰 사용 상품 금액: ",
                                coupon.minimumPrice.toLocaleString(),
                                "원 이상"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "body2",
                    className: "text-gray-400",
                    children: [
                        new Date(coupon.expiredAt).toLocaleDateString(),
                        "까지"
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsx(Typography, {
            variant: "subtitle1",
            className: "",
            children: "쿠폰 적용안함"
        })
    });
};
export default CouponSelectDialog;
